import { SEND_SHOPIFY_CONFIG, DELETE_SHOPIFY_CONFIG } from "../actions/types";
import { message } from "antd";

export default (state = [], action) => {
  switch (action.type) {
    case SEND_SHOPIFY_CONFIG:
      message.success("Shopify keys were saved successfully", 10);
      return state;
    case DELETE_SHOPIFY_CONFIG:
      message.success("Shopify keys were deleted", 10);
      return state;
    default:
      return state;
  }
};
